import { useEffect, useState } from "react";
import { APIHandlerV1 } from "hooks/api-handler-v1";
export function UseApiCall({
  url,
  method,
  paramsData,
  isHistoryURL,
  skip = false,
  isAbsoluteUrl,
}: any) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<any>();

  useEffect(() => {
    if (!skip) {
      getData();
    }
  }, [skip]);

  async function getData() {
    try {
      setIsLoading(true);
      const { data } = await APIHandlerV1({
        method,
        url,
        data: paramsData,
        isHistoryURL,
        isAbsoluteUrl,
      });
      setData(data);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }

  function refetch() {
    getData();
  }

  return { data, isLoading, error, refetch };
}
